const convertDate2Date = (d) => {
    if (!d)
        return d;
    if (typeof d === 'string')
        d = new Date(d);
    return d;
}
const convertTime2Date = (t) => {
    if (!t)
        return t;
    try {
        t = new Date(`${toStringDate(new Date())} ${t}`)
        return t
    } catch {
        return null;
    }
}
// yyyy-MM-dd HH:mm
const toStringDateTimeExternal = (d) => {
    if (!d)
        return d;
    d = convertDate2Date(d);
    let o = d.getFullYear();
    o = `${o}-${d.toLocaleDateString(['en'], { month: '2-digit' })}`;
    o = `${o}-${d.toLocaleDateString(['en'], { day: '2-digit' })}`;
    o = `${o} ${toStringTime(d)}`;
    return o;
}
// dd-MMM-yyyy HH:mm
const toStringDateTime = (d) => {
    if (!d)
        return d;
    return `${toStringDate(d)} ${toStringTime(d)}`;
}
// dd-MMM-yyyy HH:mm:ss
const toStringDateTimeSecond = (d) => {
    if (!d)
        return d;
    d = convertDate2Date(d);
    let s = d.getSeconds()
    return `${toStringDateTime(d)}:${s < 10 ? `0${s}` : s}`;
}
// dd-MMM-yyyy
const toStringDate = (d) => {
    if (!d)
        return d;
    d = convertDate2Date(d);
    let o = d.toLocaleDateString(['en'], { day: '2-digit' });
    o = `${o}-${d.toLocaleDateString(['en'], { month: 'short' })}`;
    o = `${o}-${d.getFullYear()}`;
    return o
}
// HH:mm
const toStringTime = (d) => {
    if (!d)
        return d;
    d = convertDate2Date(d);
    let h = d.toLocaleTimeString(['en'], { hour: '2-digit', hour12: false });
    let m = d.toLocaleTimeString(['en'], { minute: "2-digit" });
    return (h === '24' ? '00' : h) + ':' + (m.length === 1 ? `0${m}` : m);
}

//export
export {
    convertDate2Date,
    toStringDateTimeExternal,
    toStringDateTime,
    toStringDateTimeSecond,
    toStringDate,
    toStringTime,
    convertTime2Date,
}